export default class MenuPermission {
  constructor({
    id = 0,
    menuItem = null,
    route = null,
    icon = null,
    permissions = [],
    title = '',
    authGroups = []
  } = {}) {
    this.id = id;
    this.menuItem = menuItem;
    this.route = route;
    this.icon = icon;
    // this.rawPermissions = JSON.stringify(permissions.map(item => new PermissionGrant(item)))
    this.permissions = !permissions ? [] : permissions.map(item => new PermissionGrant(item));
    this.title = title
    this.authGroups = authGroups
  }
}

// class PermissionGroup {
//   constructor({
//     id = 0,
//     groupName = ''
//   } = {}) {
//     this.id = id;
//     this.groupName = groupName
//   }
// }
class PermissionGrant {
  constructor({
    group = {
      id: 0,
      groupName: ''
    },
    grant = true
  } = {}) {
    this.group = group;
    this.grant = grant;
  }
}